import React, { Fragment, useContext } from "react";
import { Snackbar, Alert } from "@mui/material";
import { observer } from "mobx-react-lite";

import { RootStoreContext } from "../app/store/root";

const Alerts = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    showAlertSuccess,
    messageSuccess,
    closeAlertSuccess,
    showAlertError,
    messageError,
    closeAlertError,
    showAlertInfo,
    messageInfo,
    closeAlertInfo,
  } = rootStore.alertStore;

  return (
    <Fragment>
      <Snackbar
        open={showAlertSuccess}
        autoHideDuration={6000}
        onClose={() => closeAlertSuccess()}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          variant="filled"
          onClose={() => closeAlertSuccess()}
          severity="success"
          sx={{ width: "100%" }}
        >
          {messageSuccess || ""}
        </Alert>
      </Snackbar>
      <Snackbar
        open={showAlertError}
        autoHideDuration={6000}
        onClose={() => closeAlertError()}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          variant="filled"
          onClose={() => closeAlertError()}
          severity="error"
          sx={{ width: "100%" }}
        >
          {messageError || ""}
        </Alert>
      </Snackbar>
      <Snackbar
        open={showAlertInfo}
        autoHideDuration={6000}
        onClose={() => closeAlertInfo()}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          variant="filled"
          onClose={() => closeAlertInfo()}
          severity="info"
          sx={{ width: "100%" }}
        >
          {messageInfo || ""}
        </Alert>
      </Snackbar>
    </Fragment>
  );
};

export default observer(Alerts);
